import { keymap } from 'prosemirror-keymap';
import { EditorView } from 'prosemirror-view';

import { EditorButton, RtPMPlugin } from '../../../editor/types';
import { MarkService, toggleMark } from '../../../helpers/mark-base';
import { DEFAULT_KEYMAP_INPUTRULE_PRIORITY } from '../../../helpers/utils';
import { BoldSchema } from './bold-mark';

export class BoldService<S extends BoldSchema> extends MarkService<S> {}

export class BoldPlugin implements RtPMPlugin {
  public api: {
    boldService: BoldService<BoldSchema>;
  };
  public buttons = {
    toggleBold: <EditorButton>{
      icon: 'format-bold',
      isActive: (...args) => this.api.boldService.isActive(...args),
      run: (state, dispatch) => {
        this.api.boldService.toggle(state, dispatch);
        this.editorView.focus();
      },
    },
  };

  private editorView: EditorView<BoldSchema>;

  public beforeEditorInit(schema: BoldSchema) {
    this.api = {
      boldService: new BoldService(schema.marks.strong),
    };
  }

  public afterEditorInit(editorView: EditorView<BoldSchema>) {
    this.editorView = editorView;
  }

  public getNativeEditorPlugins(schema: BoldSchema) {
    return [
      { priority: DEFAULT_KEYMAP_INPUTRULE_PRIORITY, plugin: keymap(this.getKeyBindings(schema)) },
    ];
  }

  private getKeyBindings(schema: BoldSchema) {
    return {
      'Mod-B': toggleMark(schema.marks.strong),
      'Mod-b': toggleMark(schema.marks.strong),
    };
  }
}
